// thx arco.design
import { raf, caf } from "./raf";
export function throttleByRaf(cb) {
    let timer = null;
    const throttle = function (...args) {
        timer && caf(timer);
        timer = raf(() => {
            cb(...args);
            timer = null;
        });
    };
    throttle.cancel = () => {
        caf(timer);
        timer = null;
    };
    return throttle;
}
//# sourceMappingURL=throttle-by-raf.js.map